<template>
  <div class="config-container">
    <v-card class="pa-4">
      <v-card-title>Jira Configuration</v-card-title>
      <v-card-text>
        <v-form ref="configForm" v-model="isValid">
          <v-text-field
              label="Jira Domain"
              v-model="config.domain"
              placeholder="e.g., selenium-consulting.atlassian.net"
              outlined
              :rules="[rules.required]"
          ></v-text-field>
          <v-text-field
              label="Email"
              v-model="config.email"
              placeholder="e.g., your-email@example.com"
              outlined
              :rules="[rules.required, rules.email]"
          ></v-text-field>
          <v-text-field
              label="API Token"
              v-model="config.apiToken"
              type="password"
              placeholder="Your API Token"
              outlined
              :rules="[rules.required]"
          ></v-text-field>
          <v-select
              v-model="config.projectId"
              :items="project"
              item-title="name"
              item-value="id"
              label="Select Project"
              outlined
              class="mb-3"
              @update:modelValue="loadIssueType(config.projectId)"
          ></v-select>

          <v-select
              v-model="config.issueType"
              :items="issueTypes"
              item-title="name"
              item-value="id"
              label="Select IssueType"
              outlined
              class="mb-3"
          ></v-select>

          <v-text-field
              label="Proxy URL"
              v-model="config.proxyUrl"
              outlined
              :rules="[rules.required]"
          ></v-text-field>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <div style="text-align: center" class="w-100">
          <v-btn color="primary" @click="saveConfig">Save Configuration</v-btn>
          <v-btn color="secondary" @click="loadConfig">Load Configuration</v-btn>
        </div>
      </v-card-actions>
    </v-card>

    <!-- Snackbar -->
    <v-snackbar v-model="snackbar.show" :color="snackbar.color" top>
      {{ snackbar.text }}
    </v-snackbar>
  </div>
</template>

<script>
import {saveTaskConfig, loadTaskConfig} from "@/workshop/customerFunctions";
import {JiraTracker} from "@/workshop/JiraTracker";

export default {
  name: "ConfigView",
  data() {
    return {
      tracker: {},
      project: [],
      issueTypes: [],
      config: {
        domain: "",
        email: "",
        apiToken: "",
        projectKey: "",
        projectId: "",
        issueType: "",
        proxyUrl: "https://hqm.selenium-consulting.ch/jira-proxy.php",
      },
      snackbar: {
        show: false,
        color: "success",
        text: "",
      },
      isValid: true,
      rules: {
        required: (value) => !!value || "This field is required.",
        email: (value) => /.+@.+\..+/.test(value) || "Invalid email.",
      },
    };
  },
  computed: {
    customerId() {
      return this.$route.params.customerId;
    },
  },
  methods: {
    showSnackbar(message, color = "success") {
      this.snackbar.text = message;
      this.snackbar.color = color;
      this.snackbar.show = true;
    },
    async saveConfig() {
      if (!this.isValid) {
        this.showSnackbar("Please fill all required fields", "error");
        return;
      }
      try {
        await saveTaskConfig(this.customerId, this.config);
        this.showSnackbar("Configuration saved successfully");
        await this.reloadTrackerAndProjct();
      } catch (error) {
        console.error("Failed to save configuration", error);
        this.showSnackbar("Failed to save configuration", "error");
      }
    },
    async loadConfig() {
      try {
        const config = await loadTaskConfig(this.customerId);
        if (config) {
          this.config = config;
          this.showSnackbar("Configuration loaded successfully");
          await this.reloadTrackerAndProjct();
        } else {
          this.showSnackbar("No configuration found", "info");
        }
      } catch (error) {
        console.error("Failed to load configuration", error);
        this.showSnackbar("Failed to load configuration", "error");
      }
    },
    async reloadTrackerAndProjct(){
      this.tracker = new JiraTracker(this.config);
      this.project = await this.tracker.loadProjects();
      if(this.config.projectId){
        await this.loadIssueType(this.config.projectId);
      }
    },
    async loadIssueType(projectId) {
      this.issueTypes = await this.tracker.loadIssueType(projectId);
    }
  },
  mounted() {
    this.loadConfig();
  },
};
</script>

<style>
.config-container {
  max-width: 600px;
  margin: 20px auto;
}
</style>
